import { FormattingTextBoldIcon } from '@tableau/icons/FormattingTextBoldIcon';
import { FormattingTextH1Icon } from '@tableau/icons/FormattingTextH1Icon';
import { FormattingTextH2Icon } from '@tableau/icons/FormattingTextH2Icon';
import { FormattingTextH3Icon } from '@tableau/icons/FormattingTextH3Icon';
import { FormattingTextItalicIcon } from '@tableau/icons/FormattingTextItalicIcon';
import { FormattingTextParagraphIcon } from '@tableau/icons/FormattingTextParagraphIcon';
import { FormattingTextUnderlineIcon } from '@tableau/icons/FormattingTextUnderlineIcon';
import { LinkDiagonalIcon } from '@tableau/icons/LinkDiagonalIcon';
import { TextListOrderedIcon } from '@tableau/icons/TextListOrderedIcon';
import { TextListUnorderedIcon } from '@tableau/icons/TextListUnorderedIcon';
import * as React from 'react';
import { Messages } from '../../gen-src/Localize';
import { FormatterType } from '../widgets/TextFormatter/MarkupHelpers';
import { IconLibraryIcon } from './Icons';

const IconMap: Record<FormatterType, IconLibraryIcon> = {
  Bold: FormattingTextBoldIcon,
  Heading1: FormattingTextH1Icon,
  Heading2: FormattingTextH2Icon,
  Heading3: FormattingTextH3Icon,
  Italic: FormattingTextItalicIcon,
  Link: LinkDiagonalIcon,
  OrderedList: TextListOrderedIcon,
  Paragraph: FormattingTextParagraphIcon,
  Underline: FormattingTextUnderlineIcon,
  UnorderedList: TextListUnorderedIcon,
};

export const TextFormatterNames: { [key in FormatterType]: () => string } = {
  Bold: () => Messages.bold(),
  Heading1: () => Messages.heading1(),
  Heading2: () => Messages.heading2(),
  Heading3: () => Messages.heading3(),
  Italic: () => Messages.italics(),
  Link: () => Messages.link(),
  OrderedList: () => Messages.orderedList(),
  Paragraph: () => Messages.paragraph(),
  Underline: () => Messages.underline(),
  UnorderedList: () => Messages.unorderedList(),
};

export const TextFormatterIcon: React.FC<{ type: FormatterType }> = ({ type, ...elemAttrs }) =>
  React.createElement(IconMap[type], {
    alt: TextFormatterNames[type](),
    key: `${type}_textileIcon`,
    size: 14,
    ...elemAttrs,
  });